import React, { Component } from 'react';

import IconUserProfile from '../../assets/icons/IconUserProfile';
import IconUserAccount from '../../assets/icons/IconUserAccount';
import IconUserRole from '../../assets/icons/IconUserRole';
import IconLine from '../../assets/icons/IconLine';

class MasterDataUserMenu extends Component {
    render() {
        return (
            <div className="w-full h-60 bg-blue-100 rounded-t-2xl flex justify-center items-center">
                <div className="flex items-center">
                    <div className="flex flex-col items-center">
                        <div className={this.props.page === 1 ? "bg-darkblue border-2 border-darkblue flex justify-center items-center rounded-full h-16 w-16" : "bg-white border-2 border-darkblue flex justify-center items-center rounded-full h-16 w-16"}>
                            <IconUserProfile isActive={this.props.page === 1} />
                        </div>
                        <p className={this.props.page === 1 ? "text-darkblue text-lg font-bold mt-3" : "text-darkblue text-lg mt-3"}>Profil Pengguna</p>
                    </div>
                    <div className="-mt-10 mr-5">
                        <IconLine />
                    </div>
                    <div className="flex flex-col items-center">
                        <div className={this.props.page === 2 ? "bg-darkblue border-2 border-darkblue flex justify-center items-center rounded-full h-16 w-16" : "bg-white border-2 border-darkblue flex justify-center items-center rounded-full h-16 w-16"}>
                            <IconUserAccount isActive={this.props.page === 2} />
                        </div>
                        <p className={this.props.page === 2 ? "text-darkblue text-lg font-bold mt-3" : "text-darkblue text-lg mt-3"}>Akun</p>
                    </div>
                    <div className="-mt-10 ml-5">
                        <IconLine />
                    </div>
                    <div className="flex flex-col items-center">
                        <div className={this.props.page === 3 ? "bg-darkblue border-2 border-darkblue flex justify-center items-center rounded-full h-16 w-16" : "bg-white border-2 border-darkblue flex justify-center items-center rounded-full h-16 w-16"}>
                            <IconUserRole isActive={this.props.page === 3} />
                        </div>
                        <p className={this.props.page === 3 ? "text-darkblue text-lg font-bold mt-3" : "text-darkblue text-lg mt-3"}>Peran Pengguna</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default MasterDataUserMenu;